import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { RestService } from "@stdoutsrl/design-kit";
import { api, environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private transloco: TranslocoService,private rest:RestService) {}

  ngOnInit(): void {
    this.rest.setEnviroment(environment,api)
    if(localStorage.getItem('token')){
      this.rest.setToken(localStorage.getItem('token') ?? '')
    }
    let language: any = JSON.parse(localStorage.getItem("language") ?? "null");
    let html = document.getElementById("html");
    if (language?.value) {
      this.transloco.setActiveLang(language?.value ? language?.value : "it");
      if (html && language) {
        html.lang = language?.value;
      }
    } else {
      let localLanguage = { value: "it", label: "Italiano" };
      this.transloco.setActiveLang("it");
      localStorage.setItem("language", JSON.stringify(localLanguage));
    }
    this.getTheme();
    this.getAccessibility();
    this.changeColors();
    this.invert();
  }

  changeColors() {
    let body = document.getElementById("body");

    if (body) {
      body.style.filter = `contrast(${localStorage.getItem(
        "colorAccessibility"
      )}%)`;
    }
  }

  invert() {
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${
        localStorage.getItem("isInverted") == "true"
          ? "invert(100%)"
          : "invert(0)"
      }`;
    }
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    } else {
      document.body.style.setProperty("--small", 12 + "px");
      document.body.style.setProperty("--normal", 14 + "px");
      document.body.style.setProperty("--medium", 16 + "px");
      document.body.style.setProperty("--large", 18 + "px");
      document.body.style.setProperty("--title", 24 + "px");
    }
  }
  getTheme() {
  }
}
